export default __webpack_public_path__ + "static/media/Megosu - Made.com - 2.cad95b84.jpg";